<template>
	<nav class="navbar navbar-expand-xl navbar-dark fixed-top">
		<div class="container-fluid gap-2 flex-nowrap">
			<button
				v-if="user.type !== 'siswa'"
				class="navbar-toggler px-1 py-0"
				type="button"
				data-bs-toggle="offcanvas"
				data-bs-target="#offcanvasNavbar"
				aria-controls="offcanvasNavbar"
				aria-expanded="false"
				aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<router-link to="/" class="navbar-brand hidden-xs-only me-auto">{{ title }}</router-link>
			<router-link to="/" class="navbar-brand hidden-sm-and-up me-auto fs-6">{{ title }}</router-link>
			<el-dropdown placement="bottom-end" size="large" @command="switchRoute">
				<el-avatar :size="36" v-if="user.foto" :src="user.fotoPath" :class="rute === 'profil' ? 'border border-light' : 'opacity-75'" />
				<el-avatar :size="36" v-else :class="rute === 'profil' ? 'bg-primary-subtle border border-light' : 'bg-transparent opacity-75'">
					<img v-if="rute === 'profil'" src="../assets/person.png" />
					<img v-else src="../assets/person-light.png" />
				</el-avatar>
				<template #dropdown>
					<el-dropdown-menu style="min-width: 240px; max-width: 320px">
						<el-dropdown-item class="d-block text-center text-wrap" command="profil">
							<el-avatar :size="96">
								<img v-if="user.foto" :src="user.fotoPath" />
								<img v-else src="../assets/person.png" />
							</el-avatar>
							<h6 class="mb-0">{{ user.nama }}</h6>
							<div class="text-secondary">
								<code>{{ user.username }}</code>
								<em> ~ {{ userTypes.filter((t) => t.type === user.type)[0]?.keterangan }}</em>
							</div>
							<div class="text-secondary small">{{ deskripsiRole }}</div>
						</el-dropdown-item>
						<el-dropdown-item divided command="profil" :class="{ 'active-route': rute === 'profil' }">
							<el-icon><i class="bi bi-person-gear me-2"></i></el-icon>Pengaturan Pengguna
						</el-dropdown-item>
						<el-dropdown-item @click="logout" command="profil">
							<el-icon><i class="bi bi-escape me-2"></i></el-icon>Keluar
						</el-dropdown-item>
					</el-dropdown-menu>
				</template>
			</el-dropdown>
		</div>
		<div class="offcanvas-xl offcanvas-start" data-bs-auto-close="true" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
			<div class="offcanvas-header">
				<h5 class="offcanvas-title" id="offcanvasNavbarLabel">{{ title }}</h5>
				<button type="button" class="btn-close" id="btnClose" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasNavbar" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body d-xl-none px-0">
				<app-menu data-bs-dismiss="offcanvas" aria-label="Close" data-bs-target="#offcanvasNavbar" />
			</div>
		</div>
	</nav>
</template>

<script>
import AppMenu from "./AppMenu.vue";

export default {
	name: "TopBar",
	data() {
		return {
			title: process.env.VUE_APP_TITLE,
			userTypes: [
				{ type: "admin", keterangan: "Administrator" },
				{ type: "guru", keterangan: "Guru" },
				{ type: "karyawan", keterangan: "Tenaga Kependidikan" },
			],
		};
	},
	components: {
		AppMenu,
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		userRoles() {
			const roles = this.$store.getters.getRoles;
			return roles?.map((r) => r.role) || [];
		},
		deskripsiRole() {
			const roles = this.$store.getters.getRoles;
			return roles?.map((r) => r.deskripsi).join(", ");
		},
		rute() {
			return this.$route.name;
		},
	},
	watch: {},
	mounted() {},
	methods: {
		switchRoute(dest) {
			this.$router.push({ name: dest });
		},
		async logout() {
			await this.$store.dispatch("logoutUser");
		},
	},
};
</script>

<style scoped>
nav {
	height: 60px;
	background: linear-gradient(135deg, #152746, #3763ac) !important;
	box-shadow: 0 0 16px 0 rgba(23, 58, 101, 0.25);
}
</style>
